<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div class="container-meager w-100">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Spouwmuurisolatie</h1>

      <!-- form 1 card -->
      <base-card class="container-meager w-100" :stretch-inner="true" color="alternate" :outer-padding="true">
        <base-form @submit="onSubmit">

          <!-- inputs -->
          <base-input
            type="radiobuttons" :options="yesNo"
            name="CavityWallPresent"
            v-model:value="lead.cavity_wall.general.CavityWallPresent" :validator="v$.cavity_wall.general.CavityWallPresent">
            Is er een spouwmuur aanwezig?
          </base-input>
          <issue-feedback :issue="qualStore.sections.cavity_wall.rules.CavityWallPresent" />

          <base-input
            type="select"
            name="FacadeMaterial"
            :options="facadeMaterialOptions"
            placeholder="Kies een materiaal"
            :dim-label-on-value="false"
            v-model:value="lead.cavity_wall.general.FacadeMaterial" :validator="v$.cavity_wall.general.FacadeMaterial">
            Van welk materiaal is uw buitenmuur?
          </base-input>
          <issue-feedback :issue="qualStore.sections.cavity_wall.rules.FacadeMaterial" />

          <!-- buttons -->
          <button-row class="mt-5">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="v$.cavity_wall.general.$invalid">Volgende</base-button>
          </button-row>
        </base-form>
      <!-- form card end -->
      </base-card>

      <button-row class="mt-2">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  import IssueFeedback from "@/components/IssueFeedback.vue";

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      IssueFeedback
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        facadeMaterialOptions: [
          { label: 'Stenen muur met spouw', value: 'Steen_spouw' },
          { label: 'Houtskelet', value: 'Houtskelet' },
          { label: 'Hout', value: 'Hout' },
          { label: 'Enkelsteensmuur', value: 'Enkelsteensmuur' },
          { label: 'Deels hout', value: 'Deels hout' },
          { label: 'Deels kunststof', value: 'Deels kunststof' },
          { label: 'Deels steen', value: 'Deels steen' }
        ]
      };
    },
    methods: {
      touchAndValidate() {
        this.v$.cavity_wall.general.$touch();
        return !this.v$.cavity_wall.general.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    }
  }
</script>

<style lang="scss">
</style>